import offerSchema from './offerSchema';
import { WALLET_ARRAY_COUPONS_KEY } from './constants';

const responseWalletSchema = { [WALLET_ARRAY_COUPONS_KEY]: [offerSchema] };

export default responseWalletSchema;
